<div class="table-heading">Expenses</div>

<app-filter-panel
  [filterProps]="filterProps"
  [filters]="filters"
  (filtersChanged)="onFilterChange($event)">
</app-filter-panel>

<app-table *ngIf="expenses$ | async as expenses"
  [columns]="tableColumns"
  [tableData]="expenses"
  (pageChange)="onPageChangeExpense($event)"
  (sortChange)="onSortChangeExpense($event)"
  (cellClick)="handleCellClick($event, 'expenses')">
</app-table>
